export const STATUS_MAP = {
  active: { color: 'green', text: '活跃' },
  pending: { color: 'orange', text: '待售' },
  sold: { color: 'blue', text: '已售' },
  suspended: { color: 'red', text: '封禁' },
  banned: { color: 'green', text: '起号' },
  white: { color: 'default', text: '白号' }
};

export const CATEGORY_MAP = {
  personal: { color: 'blue', text: '个人' },
  business: { color: 'green', text: '商业' },
  influencer: { color: 'purple', text: '网红' },
  entertainment: { color: 'orange', text: '娱乐' },
  education: { color: 'cyan', text: '教育' },
  other: { color: 'default', text: '其他' }
};

/** 2FA 接码网址默认值（未在系统设置中配置时使用） */
export const DEFAULT_TWO_FA_URL = 'https://2fa.dafs.top/';

/** 兼容旧引用 */
export const TWO_FA_URL = DEFAULT_TWO_FA_URL;

export const TWO_FA_URL_STORAGE_KEY = 'tk_two_fa_url';

/** 读取当前 2FA 接码网址（优先本地缓存 / 系统设置，否则用默认值） */
export function getTwoFaUrl() {
  try {
    const cached = localStorage.getItem(TWO_FA_URL_STORAGE_KEY);
    if (cached && String(cached).trim()) return String(cached).trim();
  } catch (_) {}
  return DEFAULT_TWO_FA_URL;
}

/** 缓存 2FA 接码网址到本地，供复制账号信息即时使用 */
export function setTwoFaUrlCache(url) {
  const next = (url && String(url).trim()) || DEFAULT_TWO_FA_URL;
  try {
    localStorage.setItem(TWO_FA_URL_STORAGE_KEY, next);
  } catch (_) {}
  return next;
}
